import { render } from "./organizations.vue?vue&type=template&id=f0020926&ts=true"
import script from "./organizations.ts?vue&type=script&lang=ts"
export * from "./organizations.ts?vue&type=script&lang=ts"

import "./organizations.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__